module.exports = __webpack_public_path__ + "fonts/GT-Light.e3b5bde8.otf";